"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.project.exceeded': 'Project limit reached. Upgrade your plan to create more projects.',
    'limits.project.limitReached': 'Project limit: {limit} (upgrade to create more)',
};
